export const identity = <A>(a: A): A => a;
